<template>
  <div class="form-grid">
    <div>
      <div class="floating-label">
        <select :disabled="onlyread"  v-model="profile.Identity.Title" placeholder=" " type="text">
          <option v-for="(t, tidx) in customerTypes" :value="t" :key="tidx">{{t.Label}}</option>
        </select>
        <label>{{ 'Title' | lang }}</label>
      </div>
      <div class="floating-label">
        <input :disabled="onlyread"  v-model="profile.Identity.FirstName" placeholder=" " type="text" />
        <label>{{ 'Name' | lang }}</label>
      </div>
      <div class="floating-label">
        <input :disabled="onlyread"  v-model="profile.Identity.LastName" placeholder=" " type="text" />
        <label>{{ 'LastName' | lang }}</label>
      </div>
      <div class="floating-label">
        <input :disabled="onlyread"  v-model="profile.Identity.CodeFiscal" placeholder=" " type="text" />
        <label>{{ 'FiscalCode' | lang }}</label>
      </div>
    </div>
    <div>
      <div class="floating-label">
        <input :disabled="onlyread"  v-model="birthDate" placeholder=" " type="date" />
        <label>{{ 'BirthDate' | lang }}</label>
      </div>
      <div class="floating-label">
        <input :disabled="onlyread"  v-model="profile.Identity.BirthPlace" placeholder=" " type="text" />
        <label>{{ 'BirthPlace' | lang }}</label>
      </div>
    </div>
    <div class="sticky-bottom flexrow" v-if="editing && !onlyread">
      <button class="red" @click="copyCurrentProfile" :disabled="saving">{{ 'Undo' | lang }}</button>
      <button class="green" @click="save" :disabled="saving">{{ 'Save' | lang }}</button>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import UserServices from '@/mixins/services/userServices'
import moment from 'moment'

export default {
  name: 'Anagrafica',
  props:{onlyread:Boolean},
  mixins: [ UserServices, page ],
  data () {
    return {
      profile: { Identity: {} },
      customerTypes: [],
      saving: false
    }
  },
  computed: {
    birthDate: {
      get () {
        return moment(new Date(this.profile.Identity.BirthDate)).format('YYYY-MM-DD')
      },
      set (v) {
        this.profile.Identity.BirthDate = moment(v).format('YYYY-MM-DD[T]HH:mm:ss')
      }
    },
    editing () {
      return JSON.stringify(this.profile) !== JSON.stringify(this.userProfile.profilo)
    }
  },
  methods: {
    copyCurrentProfile () {
      this.profile = this.userProfile && this.userProfile.profilo ? JSON.parse(JSON.stringify(this.userProfile.profilo)) : {}
    },
    profileIsChanged () {
      this.userProfile.profilo = JSON.parse(JSON.stringify(this.profile))
    },
    save () {
      this.saving = true
      this._saveUserIdentity(this.profile.Identity).then(() => {
        this.profileIsChanged()
        this.internalBus.$emit('notify:success', {
          text: this.dictValue('Saved'),
          key: this.notifierKey,
          timeout: 3000
        })
        this.saving = false
        this.back()
      }).catch(e => {
        console.error(e)
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : ''),
          key: this.notifierKey,
          timeout: 3000
        })
        this.saving = false
      })
    }
  },
  mounted () {
    this.copyCurrentProfile()
    this._getDataList('CustomerType').then(data => {
      this.customerTypes = data
    })
  },
  watch: {
    userProfile () {
      if (!this.profile) {
        this.copyCurrentProfile()
      }
    },

    "profile.Identity.CodeFiscal":function() {
     this.profile.Identity.CodeFiscal = this.profile.Identity.CodeFiscal.toUpperCase() 
  }
}
}
</script>

<style lang="scss"></style>
